module.exports = __webpack_public_path__ + "img/account-icon-01.91e8b2df.svg";